<column-mapper [(componentData)]="componentData"></column-mapper> 
<grid-option-config [(componentConfig)]="componentData.config"></grid-option-config> 